export default __webpack_public_path__ + "static/qa-c6068489e8c712e2054f993f1518ee77.svg";